import { Component } from '@angular/core';

@Component({
	selector: 'opus-global-nav',
	templateUrl: './global-nav.component.html',
})
export class GlobalNavComponent { }
